export enum LocationProviderEnum {
  GOOGLE = 'GOOGLE',
  NONE = 'NONE',
}
export type LocationProvider = `${LocationProviderEnum}`;
